<template>
  <div class="pay">
    <div class="share_head" v-if="false">
      <div class="left">
        <img
          src="./pay_img/logo2.png"
          width="41px"
          height="41px"
          style="flex: 1"
          alt
        />
        <div
          class="text"
          style="color: #d5d5d5; font-size: 14px; margin-left: 4px; width: 80px"
        >
          歡樂語音
        </div>
        <div
          class="text1"
          style="
            color: #d5d5d5;
            font-size: 11px;
            margin-left: 4px;
            width: 182px;
          "
        >
          線上儲值 - 便捷高效返利多！
        </div>
      </div>
      <div class="center"></div>
      <div class="right">
        <input type="text" style="display: none" />
        <div class="right-content" @click="downLaod">下載 APP</div>
      </div>
    </div>

    <div
      class="top-gf-ts"
      style="
        width: 93%;
        padding-top: 12px;
        margin: 0 auto;
        font-size: 14px;
        text-align: justify;
        line-height: 1.2;
        color: rgb(233, 29, 31);
      "
    >
      特別提醒：您可以通過瀏覽器打開我們的官方網站，並使用Google Pay進行儲值。
      儲值渠道正常運作，請您盡情享受便捷的儲值體驗。
    </div>

    <body class="body">
      <div class="body-box">
        <div
          v-if="status"
          class="warning"
          style="
      width:97%;
      margin-top:10px;
      color:#721c24;
      border-radius:6px;
      padding:5px;
      font-size:14px;
      line-height:21px;
      background-color:#f8d7da;
    }"
        >
          為了提升歌友儲值的服務品質，MyCard儲值管道{{ preserveTime.start }}至{{
            preserveTime.end
          }}進行系統升級維護！
        </div>
        <p class="title" style="margin-top: 12px; margin-left: 1px">儲值UID</p>
        <div class="input">
          <input
            type="text"
            placeholder="請輸入要儲值的歡樂語音UID"
            v-model="InputId"
            @input="input"
          />
          <div class="clear_icon" v-show="InputId.length > 0" @click="changClear"></div>
        </div>
        <div class="jr_uid_flex" v-if="localCacheUidArr.length > 0">
          <div class="jr_uid_flex_top">
            <span class="jr_uid_box_lable">儲值記錄</span>
            <div class="jr_uid_flex_top_right" @click="changClearArr">
              清空記錄
              <img src="./pay_img/clear_arr_icon.png" alt="" style="width: 13px;height: 13px;vertical-align: text-top;">
            </div>
          </div>
          <p class="jr_uid_box">
            <span v-for="(item,index) in localCacheUidArr" :key="index" class="jr_uid_item" @click="changJrUid(item)" :class="{sel_item_color: InputId == item}">
              {{item}}
            </span>
          </p>
          </div>

          <p class="title">UID確認</p>

        <div class="user_info">
          <div>
            <img
              class="user-avater"
              v-if="init_img"
              :src="init_img"
              width="64"
              height="64"
              alt
            />
            <img
              class="user-avater"
              width="64"
              height="64"
              v-else
              :src="'http://api.happytalk.tw/userimg.php?uid=' + userUrlId"
              alt=""
            />
          </div>

          <div class="user-name">
            {{ userName }}
            <br />
            <small>〈{{ userID }}〉</small>
          </div>
        </div>

        <p class="title">儲值方式</p>
        <p style="padding-top: 12px; color: #e91d1f; font-size: 13px">
          注意：總返利包含平臺100%返利+儲值管道額外返利，如單筆儲值600鑽石，總返利105%，最終可獲得1230鑽石。計算公式：單筆儲值數+單筆儲值數*總返利比率=獲得鑽石總數。
        </p>

        <div class="pay_types">
          <a
            class="mycard"
            :class="{ active: isactive == 0 }"
            @click="choose(0)"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'myCard') }}
            </div>
            <img
              src="./pay_img/mycard.png"
              width="304"
              height="64"
              alt
              style="margin-top: 20px"
            />
            <!-- <p style="margin-top:12px;">{{ status ? '維護中' : '點數卡/ATM/電信支付/會員扣點' }}</p> -->
          </a>

          <!-- <a
            v-if="isShow"
            class="mycard"
            :class="{ active: isactive == 3 }"
            @click="choose(3)"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'FunPoint') }}、20倍金幣
            </div>
            <div class="img_list_box">
              <div class="img_list">
                <img
                  src="./pay_img/VISA.png"
                  alt=""
                  style="width: 53px; height: 33px"
                />
                <img
                  src="./pay_img/master.png"
                  alt=""
                  style="width: 60px; height: 37px"
                />
                <img
                  src="./pay_img/jcb.png"
                  alt=""
                  style="width: 45px; height: 34px"
                />
                <img
                  src="./pay_img/yl.png"
                  alt=""
                  style="width: 44px; height: 28px"
                />
              </div>
            </div>
            
          </a> -->
          <a
            class="mycard"
            :class="{ active: isactive == 7 }"
            @click="choose(7)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}、10倍金幣
            </div>
            <div class="bage">台灣</div>
            <!-- <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" /> -->
            <div class="img_list_box">
              <div class="img_list">
                <img
                  src="./pay_img/VISA_MasterCard_C_A_3x.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                 <img
                  src="./pay_img/jie_icon.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <!-- <img
                  src="./pay_img/7-Eleven_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                /> -->
                <!-- <img
                  src="./pay_img/FamilyMart_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/OKMart_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Hi-Life_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                /> -->
                <img
                  src="./pay_img/Apple_Pay_Global_3x.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Google_Pay_Global.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
              </div>
            </div>
            <!-- <p style="color:#d8162f;">另返10倍金幣</p> -->
            <!-- <p>超商掃描付款</p> -->
          </a>

          <!-- <a
                        class="mycard"
                        :class="{ active: isactive == 1 }"
                        @click="choose(1)"
                        style="margin-top:20px"
                    >
                        <img src="./pay_img/iPasspay.jpg" width="160" height="37" alt="" />
                        <p>信用卡支付</p>
                    </a> -->
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 1 }"
            @click="choose(1)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}
            </div>
            <div class="bage">台灣</div>
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" />
            <p>超商掃描付款</p>
          </a> -->
          <a
            class="mycard"
            :class="{ active: isactive == 6 }"
            @click="choose(6)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}、10倍金幣
            </div>
            <div class="bage">馬來西亞</div>
            <!-- <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" /> -->
            <div class="img_list_box">
              <div class="img_list">
                <img
                  src="./pay_img/VISA_MasterCard_C_A_3x.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <img
                  src="./pay_img/Touch'n_Go_MY.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Grabpay_MY.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Axiata_Boost_MY.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Apple_Pay_Global_3x.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Google_Pay_Global.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Duitnow_QR_MY_3x.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
              </div>
            </div>
            <!-- <p style="color:#d8162f;">另返10倍金幣</p> -->
            <!-- <p>超商掃描付款</p> -->
          </a>
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 2 }"
            @click="choose(2)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}
            </div>
            <div class="bage">馬來西亞</div>
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" />
            <p>超商掃描付款</p>
          </a> -->
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 4 }"
            @click="choose(4)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}
            </div>
            <div class="bage">新加坡</div>
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" />
            <p>超商掃描付款</p>
          </a> -->
          <!-- <a
            class="mycard"
            :class="{ active: isactive == 5 }"
            @click="choose(5)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}
            </div>
            <div class="bage">香港</div>
            <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" />
            <p>超商掃描付款</p>
          </a> -->
          <a
            class="mycard"
            :class="{ active: isactive == 8 }"
            @click="choose(8)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}、10倍金幣
            </div>
            <div class="bage">香港</div>
            <!-- <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" /> -->
            <div class="img_list_box">
              <div class="img_list">
                <img
                  src="./pay_img/VISA_MasterCard_C_A_3x.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <!-- 暂时隐藏 -->
                <!-- <img
                  src="./pay_img/AlipayHK_HK.png"
                  alt=""
                  style="width: 48px; height: 48px"
                /> -->
                <img
                  src="./pay_img/Apple_Pay_Global_3x.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <img
                  src="./pay_img/Google_Pay_Global.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
              </div>
            </div>
            <!-- <p style="color:#d8162f;">另返10倍金幣</p> -->
            <!-- <p>超商掃描付款</p> -->
          </a>
          <a
            class="mycard"
            :class="{ active: isactive == 9 }"
            @click="choose(9)"
            style="margin-top: 20px"
          >
            <div class="rebate">
              {{ setRebateTime(1, 'payerMAX') }}、10倍金幣
            </div>
            <div class="bage">新加坡</div>
            <!-- <img src="./pay_img/Payermax.jpg" width="160" height="37" alt="" /> -->
            <div class="img_list_box">
              <div class="img_list">
                <img
                  src="./pay_img/VISA_MasterCard_C_A_3x.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Grabpay_SG.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <img
                  src="./pay_img/eNETS_SG.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/PayNow_SG.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Apple_Pay_Global_3x.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/Google_Pay_Global.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
              </div>
            </div>
            <!-- <p style="color:#d8162f;">另返10倍金幣</p> -->
            <!-- <p>超商掃描付款</p> -->
          </a>

          <a
            class="mycard"
            :class="{ active: isactive == 11 }"
            @click="choose(11)"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <img
              class="google_png"
              src="./pay_img/Google.png"
              width="35%"
              height="auto"
              alt
              style="margin-top: 20px"
            />
            <!-- <p style="margin-top:12px;">{{ status ? '維護中' : '點數卡/ATM/電信支付/會員扣點' }}</p> -->
          </a>

          <a
            class="mycard mycard-width"
            :class="{ active: isactive == 10 }"
            @click="choose(10)"
            style="margin-top: 20px"
            v-if="false"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <div class="img_list_box">
              <div class="img_list">
                <!-- <img
                  src="./pay_img/Touch'n_Go_MY.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <img
                  src="./pay_img/Axiata_Boost_MY.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/LINE_Pay_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/AlipayHK_HK.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/DANA_ID.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                /> -->
                <img
                  src="./pay_img/zfb_icon.png"
                  alt=""
                  style="width: 48px; height: 48px;"
                />
              </div>
            </div>
          </a>

           <a
            class="mycard mycard-width"
            :class="{ active: isactive == 12 }"
            @click="choose(12)"
            style="margin-top: 20px"
            v-if="false"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <div class="img_list_box">
              <div class="img_list">
                <!-- <img
                  src="./pay_img/Touch'n_Go_MY.png"
                  alt=""
                  style="width: 48px; height: 48px"
                />
                <img
                  src="./pay_img/Axiata_Boost_MY.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/LINE_Pay_TW.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/AlipayHK_HK.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                />
                <img
                  src="./pay_img/DANA_ID.png"
                  alt=""
                  style="width: 48px; height: 48px; margin-left: 15px"
                /> -->
                <!-- <img
                  src="./pay_img/LINE_Pay_q.png"
                  alt=""
                  style="width: 48px; height: 48px;"
                /> -->
                <img src="./pay_img/WeChat_Pay_CN.png" style="width: 48px; height: 48px;" alt/>
              </div>
            </div>
          </a>

          <!-- 暂时隐藏 -->
          <a
            class="mycard mycard-width"
            :class="{ active: isactive == 14 }"
            @click="choose(14)"
            style="margin-top: 20px"
            v-if="false"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <div class="img_list_box">
              <div class="img_list">
                <img src="./pay_img/AlipayHK_HK.png" style="width: 48px; height: 48px;" alt/>
              </div>
            </div>
          </a>

          <a
            class="mycard mycard-width"
            :class="{ active: isactive == 13 }"
            @click="choose(13)"
            style="margin-top: 20px"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <div class="img_list_box">
              <div class="img_list">
                <img src="./pay_img/Apple_Pay_Global_3x.png" style="width: 48px; height: 48px;" alt/>
              </div>
            </div>
          </a>

          <a
            class="mycard mycard-width"
            :class="{ active: isactive == 15 }"
            @click="choose(15)"
            style="margin-top: 20px"
          >
            <div class="rebate">{{ setRebateTime(1, 'AirSC') }}、10倍金幣</div>
            <div class="bage" style="width: auto; min-width: 86px">全球</div>
            <div class="img_list_box">
              <div class="img_list">
                <img src="./pay_img/WeChat_Pay_CN.png" style="width: 48px; height: 48px;" alt/>
              </div>
            </div>
          </a>

        </div>

        <a class="next" @click="getOrderList" ref="next">下一步</a>
      </div>
    </body>

    <footer class="footer">
      <div class="page-footer">如有問題請聯絡官方小秘書(ID:10400)</div>
    </footer>
  </div>
</template>

<script>
import { Toast,Dialog } from 'vant';
import { Base64 } from 'js-base64'
export default {
  name: 'pay',
  data () {
    return {
      userInfo: [],
      userName: '用戶暱稱',
      userID: ' 用戶UID ',
      isactive: 0, //0默认点数卡为选中
      InputId: '',
      hasUser: 0,
      hasUserStatus: false,
      init_img: require('./pay_img/m_head.png'),
      dataList: [],
      timer: null,
      userUrlId: '',
      status: false, //是否在维护
      preserveTime: '', //維護時間段
      isShow: false,
      localCacheUidArr: [], //鍵入ID
      cancelToken: null,
      cancel: null
    }
  },
  components: {
    // [Dialog.Component.name]: Dialog.Component,
  },
  watch: {
  },
  methods: {
    //判断是否是app内打开
    isHappyTalk () {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.match(/happytalk/i) == 'happytalk') {
        return true;
      } else {
        return false;
      }
    },
    choose (isactive) {
      if (this.status && isactive == 0) {
        alert('MyCard維護中')
        return
      }
      this.isactive = isactive
    },
    //获取是否在维护状态
    getStatus () {
      var time = [{ start: '2021-6-28 8:00', end: '2021-6-28 9:30' }]
      var now = Math.round(new Date() / 1000),
        start,
        end

      return time.find(item => {
        start = Math.round(new Date(item.start) / 1000)
        end = Math.round(new Date(item.end) / 1000)
        return now >= start && now <= end
      })
    },
    setRebateTime (show = 0, type) {
      // console.log(show, type)
      var objKey = {
        myCard: {
          text: '總返利105%',
          show_time: [{ start: '2024/4/23 00:00:00', end: '2024/4/28 23:59:59', text: '總返利111%' }]
        },
        payerMAX: {
          text: '總返利106%',
          show_time: [{ start: '2024/4/23 00:00:00', end: '2024/4/28 23:59:59', text: '總返利112%' }]
        },
        FunPoint: {
          text: '總返利107%',
          show_time: [{ start: '2024/4/23 00:00:00', end: '2024/4/28 23:59:59', text: '總返利113%' }]
        },
        AirSC: {
          text: '總返利106%',
          show_time: [{ start: '2024/4/23 00:00:00', end: '2024/4/28 23:59:59', text: '總返利112%' }]
        },
      }
      if (show) {
        objKey[type].new_text = ''
        let now = Math.round(new Date() / 1000),
          start,
          end
        objKey[type].show_time.forEach(v => {
          start = Math.round(new Date(v.start) / 1000)
          end = Math.round(new Date(v.end) / 1000)
          if (now >= start && now <= end) {
            objKey[type].new_text = v.text
          }
        });
        return objKey[type].new_text ? objKey[type].new_text : objKey[type].text
      } else {
        return objKey[type].text
      }
    },
    input () {

      // 取消之前的请求
      if (this.cancel) {
        this.cancel('取消前序请求')
      }

      if (this.timer !== null) {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.getUserInfo()
        }, 400)
      } else {
        this.timer = setTimeout(() => {
          this.getUserInfo()
        }, 400)
      }
    },
    changClear(){
      this.InputId = ''
      this.input()
    },
    changClearArr(){
      localStorage.removeItem('localCacheUidArr');
      this.localCacheUidArr = []
    },
    getOrderList () {
      //app打开谷歌充值提示
      if (this.isHappyTalk() && this.isactive == 11) {
        // Toast('前往官網儲值')
        Dialog.alert({
          title: '溫馨提示',
          message: '因權限問題，Google pay付款管道需移步到瀏覽器打開才能進行儲值',
          theme: 'round-button',
          confirmButtonText: '移步瀏覽器',
          closeOnClickOverlay: true,
          confirmButtonColor: '#1eaeee'
        }).then(() => {
          this.externalOpen()
        });
        return
      }
      // this.$router.push('order')
      var api, type
      if (this.isactive == 0) {
        type = 1 //表示第一种充值方式
        api = '../api/api2.php?c=commodity._mycardCommodityList&type=1'
      }
      // else if (this.isactive == 1) {
      //     type = 2 //表示第二种充值方式
      //     api = '../api/api2.php?c=commodity._iPasspayCommodityList&type=1'
      // }
      else if (this.isactive == 1) {
        type = 3 //表示第三种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=TWD'
      } else if (this.isactive == 2) {
        type = 4 //表示第四种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=MYR'
      } else if (this.isactive == 4) {
        type = 6 //表示第六种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=SGD'
      } else if (this.isactive == 5) {
        type = 7 //表示第七种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=HKD'
      } else if (this.isactive == 6) {
        type = 4 //表示第四种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=USD&region=MY'
      } else if (this.isactive == 7) {
        type = 3 //表示第三种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=USD&region=TW'
      } else if (this.isactive == 8) {
        type = 7 //表示第七种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=USD&region=HK'
      } else if (this.isactive == 9) {
        type = 6 //表示第六种充值方式
        api = '../api/api2.php?c=commodity._payermaxCommodityList&type=1&unit=USD&region=SG'
      } else if (this.isactive == 10) {
        type = 8 //表示第八种充值方式
        api = '../api/api2.php?c=commodity._airsecurecardCommodityList&type=1&channel=AC'
      } else if (this.isactive == 11) {
        type = 11 //表示第八种谷歌充值方式
        api = '../api/api2.php?c=commodity._payermaxChannelCommodityList&type=1&unit=USD&channel=GOOGLEPAY'
      } else if (this.isactive == 12) {
        type = 8 //表示第八种充值方式
        // LINE_Pay充值
        // api = '../api/api2.php?c=commodity._airsecurecardCommodityList&type=1&channel=RL'
        // 微信全球支付
        api = '../api/api2.php?c=commodity._airsecurecardCommodityList&type=1&channel=WECHAT_NATIVE'
      } else if (this.isactive == 13) {
        type = 13 //表示全球第八种APPLEPAY充值方式
        api = '../api/api2.php?c=commodity._payermaxChannelCommodityList&type=1&unit=USD&channel=APPLEPAY'
      } else if (this.isactive == 14) {
        type = 8 //表示第八种充值方式
        // 支付宝全球支付
        api = '../api/api2.php?c=commodity._airsecurecardCommodityList&type=1&channel=AH'
      } else if (this.isactive == 15) {
        type = 15
        api = '../api/api2.php?c=commodity._huitechCommodityList&type=1'
      }
      else {
        type = 5 //表示第四种充值方式
        api = '../api/api2.php?c=commodity._omgCommodityList&type=1'
      }
      if (this.hasUserStatus) {
        this.$axios.get(api).then(res => {
          this.dataList = res.data.data
          this.setLocalCacheUid(this.userInfo.data.uid)
          this.$router.push({
            path: 'order',
            query: { datalist: encodeURIComponent(JSON.stringify(this.dataList)), userInfo: encodeURIComponent(JSON.stringify(this.userInfo)), type },
          })
        })
      } else {
        alert('請您輸入賬號或者輸入正確賬號')
      }
    },
    async getUserInfo () {
      if (this.InputId.length >= 5) {

        // 创建新的 CancelToken
        this.cancelToken = new this.$axios.CancelToken(c => {
          this.cancel = c
        })

        try {
          
          await this.$axios
          .get(`../api/api.php?c=user._getUserCard&get_user_id=${this.InputId}`,{cancelToken: this.cancelToken})
          .then(res => {
            this.userInfo = res.data
            if (res.data.code != this.hasUser || !res.data.data.uid) {
              this.$refs.next.style.background = '#6c757d'
              this.init_img = require('./pay_img/m_head.png')
              this.userName = '用戶不存在'
              this.userID = 'ID不存在'
              this.hasUserStatus = false
              sessionStorage.removeItem('payUid')
            } else {
              this.$refs.next.style.background = '#1278f3'
              this.init_img = false
              this.userUrlId = this.InputId
              sessionStorage.setItem('payUid', res.data.data.uid)
              // this.setLocalCacheUid(res.data.data.uid)
              this.userName = res.data.data.nickname
              this.userID = res.data.data.uid
              this.hasUserStatus = true
            }
          })

        } catch (error) {
          //取消之前请求
          if (this.$axios.isCancel(error)) {
            console.log('请求被取消:', error.message)
          } else {
            console.log('搜索出错:', error)
          }
        }
      }else if(this.InputId.length < 5){
        this.$refs.next.style.background = '#6c757d'
        this.init_img = require('./pay_img/m_head.png')
        this.userName = '用戶不存在'
        this.userID = 'ID不存在'
        this.hasUserStatus = false
        sessionStorage.removeItem('payUid')
      }
    },
    setLocalCacheUid(uid){
      try {
         const index = this.localCacheUidArr.findIndex( v => v == uid)
          if (index > -1) {
            this.localCacheUidArr.splice(index, 1);
            this.localCacheUidArr.unshift(uid)
          }else{
            if (this.localCacheUidArr.length >= 5) {
              this.localCacheUidArr.pop();
            }
            this.localCacheUidArr.unshift(uid)
          }
          // console.log(this.localCacheUidArr)
          localStorage.setItem('localCacheUidArr', JSON.stringify(this.localCacheUidArr))
      } catch (error) {
        console.log(error)
      }
    },
    changJrUid(uid){
      if (this.InputId == uid) {
        return
      }
      this.InputId = uid
      this.input()
    },
    //节流函数
    // debounce (fn,delay = 300) {
    //     var timer = null
    //     return function() {
    //         if (timer != null) {
    //             clearTimeout(timer)
    //         }else{
    //             timer = setTimeout(fn,delay)
    //         }
    //     }
    // },
    downLaod () {
      if (this._isMobile()) {
        this.isIosorAndroid()
      } else {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_pc',
        })
        _hmt.push(['_trackEvent', 'share_music', 'pc', 'pc'])
        window.location.href = '../api/jump.php?targer=pc'
      }
    },
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    isIosorAndroid () {
      const u = navigator.userAgent,
        app = navigator.appVersion
      //const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (isiOS) {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_ios',
        })
        _hmt.push(['_trackEvent', 'share_music', 'ios', 'ios_app'])
        window.location.href = '../api/jump.php?targer=ios'
      } else {
        gtag('event', 'view_promotion', {
          promotion_name: 'pay_android',
        })
        _hmt.push(['_trackEvent', 'share_music', 'android', 'android_app'])
        window.location.href = '../api/jump.php?targer=android'
      }
    },
    getQueryString (name = '') {
      const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      const r =
        window.location.search.substr(1).match(reg) ||
        window.location.hash.substring(window.location.hash.search(/\?/) + 1).match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      }
    },
    // 外部打開官網
    externalOpen(){
      var urlStr = ''
      if (this.hasUserStatus) {
          if(process.env.VUE_APP_ENV == 'staging'){
          urlStr = `http://happytalk.tw/mycard/newPayTest/pay/?funpoint=1&uid=${this.userInfo.data.uid}`
        }else{
          urlStr = `http://happytalk.tw/mycard/newPay/pay/?funpoint=1&uid=${this.userInfo.data.uid}`
        }
      }else{
          if(process.env.VUE_APP_ENV == 'staging'){
          urlStr = `http://happytalk.tw/mycard/newPayTest/pay/?funpoint=1`
        }else{
          urlStr = `http://happytalk.tw/mycard/newPay/pay/?funpoint=1`
        }
      }
      const urlBase64 = Base64.encode(urlStr)
      window.location.href = 'happytalk://happytalk.app/OpenExternalLinks?url=' + urlBase64
    }
  },
  mounted () {
    const uid = this.getQueryString('uid') || sessionStorage.getItem('payUid')
    const localCacheUidArr = localStorage.getItem('localCacheUidArr')
    this.localCacheUidArr = localCacheUidArr ? JSON.parse(localCacheUidArr) : []
    if (uid !== '' && uid !== undefined && uid !== null) {
      this.InputId = uid
      this.input()
    }
    this.preserveTime = this.getStatus()
    if (this.preserveTime) {
      this.status = true
      this.isactive = 1
    }
    if (this.getQueryString('funpoint') == 1) {
      this.isShow = true
      // this.isactive = 3
    }
  },
}
</script>

<style lang="stylus" scoped>
.pay {
  .share_head {
    display: flex;
    width: 100%;
    height: 62.4px;
    background-color: #313131;

    .left {
      position: relative;
      flex: 4;

      img {
        position: absolute;
        top: 50%;
        margin-top: -20.5px;
        left: 50%;
        margin-left: -42.5px;
      }

      .text {
        position: absolute;
        top: 50%;
        margin-top: -18.5px;
        left: 51%;
        margin-left: -42.5px;
      }

      .text1 {
        width: 333px;
        position: absolute;
        top: 49%;
        margin-top: 5.5px;
        left: 51%;
        margin-left: -42.5px;
      }
    }

    .center {
      flex: 8;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.8rem;
      color: #ffffff;
    }

    .right {
      flex: 4;
      display: flex;
      justify-content: center;
      align-items: center;

      .right-content {
        border-radius: 2px;
        width: 67px;
        height: 24px;
        font-size: 12px;
        background: #1278F3;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #ffffff;
      }
    }
  }

  .body {
    width: 100%;

    .body-box {
      width: 93%;
      margin: 0 auto;

      .title {
        padding-top: 13px;
        font-size: 90%;
        font-weight: bold;
        font-family: Microsoft JhengHei;
        flex-shrink: 0;
      }

      .jr_uid_flex{
        padding-top: 13px;
        width: 99%;
      }

      .jr_uid_flex_top{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .jr_uid_flex_top_right{
          //  display: flex;
          // align-items: center;
          font-size: 75%;
          font-weight: 400;
          color: #999999;
          cursor: pointer;
        }
      }

      .jr_uid_box {
        padding-top: 3px;
        font-size: 75%;
        font-weight: bold;
        font-family: Microsoft JhengHei;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
      .jr_uid_box_lable{
        font-size: 90%;
        font-weight: bold;
        font-family: Microsoft JhengHei;
      }
      .jr_uid_item{
        margin-top: 10px;
        min-width 64px;
        height 25px;
        line-height 25px;
        box-sizing: border-box;
        background-color: #F6F6F6;
        // border: 1px solid #F1F1F1;
        border-radius: 14px;
        margin-right: 10px;
        padding: 0 2px;
        text-align: center;
        cursor: pointer;
        color: #666666;
        &.sel_item_color{
          background-color: #1F81B5;
          color: #FFFFFF;
        }
        &:last-child{
          margin-right: 0;
        }
      }

      .input {
        width: 97%;
        margin-top: 11px;
        height: 38px;
        position: relative;
        input {
          width: 100%;
          height: 38px;
          border: 1px solid #C9C8CB;
          padding-left: 10px;
          border-radius: 6px;
        }
        .clear_icon{
          width: 19px;
          height: 19px;
          background: url('./pay_img/clear_icon.png') no-repeat;
          background-size: 100% 100%;
          position: absolute;
          right: -6px;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
        }
      }

      .user_info {
        margin-top: 13px;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;

        .user-avater {
          border-radius: 50%;
          border: 1px solid #ccc;
        }

        .user-name {
          text-align: center;
          height: 72px;
          line-height: 33px;

          small {
            line-height: 5px;
            font-size: 12px;
          }
        }
      }

      .pay_types {
        display: flex;
        flex-wrap: wrap;
        width: 100%;

        .mycard {
          position: relative;
          flex: 0 0 100%;
          height: 172px;
          // height: 125px;
          // height: 73.28px;
          border: 1px solid #A5B1B8;
          // border: 1px solid rgba(0, 0, 0, 0.3);
          border-radius: 4px;
          text-align: center;
          overflow: hidden;
          margin-top: 12px !important;
          // box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.3);
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;

          .img_list_box {
            width: 100%;
            display: flex;
            padding: 10px 0 0px 0;
            // padding: 20px 0 0px 0;
            align-items: center;
            justify-content: center;
          }

          .img_list {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;

            // overflow-x: auto;
            // padding: 15px 0 10px 0;
            &>img {
              margin-top: 10px;
              margin-left: 20px;

              &:first-child {
                margin-left: 0 !important;
              }
            }
          }

          img {
            // margin-top: 5px;
          }

          &>p {
            margin-top: 10px;
            font-size: 14px;
          }
        }

        .active {
          background: #fff;
          border: 1px solid #F55D3E;
          // border: 1px solid #fc178a;
          color: #F55D3E;

          .bage {
            background: #f46c54;
          }
        }
      }

      .next {
        display: inline-block;
        margin-top: 20px;
        width: 100%;
        height: 38px;
        line-height: 38px;
        text-align: center;
        background-color: #6c757d;
        border-color: #6c757d;
        opacity: 0.65;
        font-size: 16px;
        color: #fff;
        border-radius: 4px;
      }
    }
  }

  .footer {
    width: 100%;
    padding: 20px 0;

    .page-footer {
      color: #a5a5a5;
      font-size: 80%;
      text-align: center;

      a {
        display: inline-block;
        color: #007bff;
      }
    }
  }

  .bage {
    width: 86px;
    // font-size: 15px;
    font-size: 12px;
    color: #fff;
    background: #a5b1b8;
    position: absolute;
    top: 0;
    right: 0;
    // height: 36px;
    // line-height: 36px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    // line-height: 25px;
    border-radius: 0 0 0 4px;
    // border: 1px solid #fd178a;
    // font-size: 14px;
    // color: #E800F4;
    // background-color #fff
  }

  .rebate {
    min-width: 86px;
    font-size: 14px;
    color: #fff;
    // background: linear-gradient(0deg, #fc1689 73%, #e526f2 100%);
    background: #EB180D;
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    text-align: center;
    line-height: 24px;
    border-radius: 0 0 4px 0;
    padding: 0 10px;
  }
}
</style>
